import { create } from 'zustand';

import themes from '../theme';
import { sendTheme } from '../channels/themeChannel';

const getInitialMode = () => {
    
    const saved = localStorage.getItem('themeMode');

    if (saved === 'light' || saved === 'dark') {
        return saved;
    }

    const prefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)'
    ).matches;

    return prefersDark ? 'dark' : 'light';
};

export const useThemeModeStore = create((set, get) => ({
    
    mode: getInitialMode(),

    setMode: (mode, broadcast = true) => {

        localStorage.setItem('themeMode', mode);

        set({ mode });

        if (broadcast) {
        
            sendTheme({mode});

        }

    },

    toggleTheme: () => {

        const nextMode =
        get().mode === 'light'
            ? 'dark'
            : 'light';

        get().setMode(nextMode);

    },

    getTheme: () => themes[get().mode]

}));